import React, { useState, useEffect } from "react";
import {
  makeStyles,
  Box,
  Typography,
  Container
} from "@material-ui/core";
import Page from "src/components/Page";
import actions from "src/duck/global/actions";
import { connect } from "react-redux";
import KmFilteredTable from "src/components/common/KmFilteredTable";
import { apiEndpoints, apiGetRequest } from "src/utils/api/api";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import KmPageTitle from "src/components/layout/KmPageTitle"

const useStyles = makeStyles((theme) => ({
  root: {
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  massagebox: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  title: {
    marginLeft: theme.spacing(3.5),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    flexGrow: 1,
  },
}));


const IllegalAccess = ({ enableGlobalLoader, disableGlobalLoader }) => {
  const classes = useStyles();

  const [rows, setRows] = useState([]);
  const [reloadCounter, setReloadCounter] = useState(0);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    enableGlobalLoader();
    apiGetRequest(apiEndpoints.getIllegalAccessLog.path, true)
      .then((data) => {
        disableGlobalLoader();
        setRows(data);
      })
      .catch((error) => {
        disableGlobalLoader();
      });
    return () => {};
  }, [reloadCounter]);

  const headCells = [
    {
      id: "eventUser",
      numeric: false,
      disablePadding: true,
      fieldName: "eventUser",
      sortable: true,
      main: true,
      label: "Login użytkownika",
    },
    {
      id: "eventDate",
      fieldName: "eventDate",
      numeric: false,
      disablePadding: false,
      sortable: true,
      searchable: true,
      label: "Data/czas zdarzenia",
    },
    {
      id: "eventDesc",
      fieldName: "eventDesc",
      numeric: false,
      disablePadding: false,
      sortable: true,
      searchable: true,
      label: "Opis zdarzenia",
    },
  ];


  return (
    <Page
      className={classes.root}
      title="Administracja - Nieuprawniony dostęp"
    >
      <KmPageTitle>
        Nieuprawniony dostęp
      </KmPageTitle>
      <Container maxWidth={false}>
        <Box mt={3}>
          <KmFilteredTable markable={false} headCells={headCells} rows={rows} />
        </Box>
      </Container>
    </Page>
  );
};

const mapDispatchToProps = (dispatch) => ({
  enableGlobalLoader: () => dispatch(actions.enableGlobalLoader()),
  disableGlobalLoader: () => dispatch(actions.disableGlobalLoader()),
});

export default connect(null, mapDispatchToProps)(IllegalAccess);
